export function getDropShipValue(entity) {
	return entity.IsDropShipAllowed && entity.IsDropShipAvailable ? 'yes' : 'no';
}

export function getSoldOutValue(value) {
	return value ? value : 'Sold Out';
}

export function getYesNoValue(value) {
	return value ? 'Yes' : 'No';
}

export function getSeeComponentsValue(value, isPack) {
	return isPack ? 'See Components' : value;
}

export function canOrderItems(bpNumber) {
	return bpNumber !== '';
}



// WEBPACK FOOTER //
// ./src/api/helpers/entity.js